import { connector as api_connector } from "@/api";
import { DateTime } from "luxon";

import { client } from "@/api/client";
import { getField, updateField } from 'vuex-map-fields';
import { iva_order_company } from "../../modules/invoices/domain/Invoice"

// Types
export const FETCH_CONNECTOR_BEGIN = "FETCH_CONNECTOR_BEGIN";
export const FETCH_CONNECTOR_ERROR = "FETCH_CONNECTOR_ERROR";
export const FETCH_CONNECTOR_SUCCESS = "FETCH_CONNECTOR_SUCCESS";

export const WRITE_CONNECTOR_BEGIN = "WRITE_CONNECTOR_BEGIN";
export const WRITE_CONNECTOR_ERROR = "WRITE_CONNECTOR_ERROR";
export const WRITE_CONNECTOR_SUCCESS = "WRITE_CONNECTOR_SUCCESS";

export const RESET_CONNECTOR = "RESET_CONNECTOR";
export const SET_ROWS_PER_PAGE = "SET_ROWS_PER_PAGE";

export const SET_NSTFILESPATHS = "SET_NSTFILESPATHS";

export const SET_CURRENT_FILTERS = "SET_CURRENT_FILTERS";
export const CLEAN_FILTERS = "CLEAN_FILTERS";
export const SET_TYPE_CHOICES = "SET_TYPE_CHOICES";
export const SET_COMPANYDB_TYPES = "SET_COMPANYDB_TYPES";
export const SET_LOAD_PATH_TYPES = "SET_LOAD_PATH_TYPES";
export const SET_LOCATIONS = "SET_LOCATIONS";

export const SET_ASYNC_JOB_ID = "SET_ASYNC_JOB_ID";
export const SET_ASYNC_JOB_STATE = "SET_ASYNC_JOB_STATE";
export const ADD_REFRESH_ACCOUNTS_ACTION = "ADD_REFRESH_ACCOUNTS_ACTION";
export const ADD_MASSIVE_COMPANYDB_LINK_ACTION = "ADD_MASSIVE_COMPANYDB_LINK_ACTION";
export const CHANGE_MASSIVE_COMPANYDB_LINK_ACTION = "CHANGE_MASSIVE_COMPANYDB_LINK_ACTION";
export const ACTIVE_TRAINING_MESSAGE = "ACTIVE_TRAINING_MESSAGE";
export const INACTIVE_TRAINING_MESSAGE = "INACTIVE_TRAINING_MESSAGE";
export const ACTIVE_INSTALATION_MESSAGE = 'ACTIVE_INSTALATION_MESSAGE';
export const INACTIVE_INSTALATION_MESSAGE = 'INACTIVE_INSTALATION_MESSAGE';
export const ADD_MASSIVE_DEACTIVATE_COMPANYDB_LINK_ACTION = "ADD_MASSIVE_DEACTIVATE_COMPANYDB_LINK_ACTION";

export const SET_CSV_ONE_LINE_HEADERS = "SET_CSV_ONE_LINE_HEADERS";
export const SET_CSV_ONE_LINE_HIDDEN_HEADERS = "SET_CSV_ONE_LINE_HIDDEN_HEADERS";
export const SET_CSV_MULTI_LINE_HEADERS = "SET_CSV_MULTI_LINE_HEADERS";
export const SET_CSV_MULTI_LINE_HIDDEN_HEADERS = "SET_CSV_MULTI_LINE_HIDDEN_HEADERS";
export const SET_USERS_CDB_WITH_SETTINGS = "SET_USERS_CDB_WITH_SETTINGS";
export const SET_OAUTH_PARAMS = "SET_OAUTH_PARAMS";
export const SET_OAUTH_APP = "SET_OAUTH_APP";

const add_tipos = (conf)=>{
  if(conf && conf.tipos_iva){
    let res=[];
    
    iva_order_company.forEach((e)=>{
        let found=false;
        let found_conf = {};
        conf.tipos_iva.forEach((conf_e)=>{
          if(e==conf_e.iva){
            found=true
            found_conf=conf_e
          }
        })
        if(!found){
          res.push({"iva": e, "base": "base_"+e, "tipo": e, "customer_count": '',
           "customer_descr": "", "supplier_count": '', "supplier_descr": "", 
           "customer_account": "", "customer_recargo": '', "supplier_account": "", 
           "supplier_recargo": '', "customer_id_contanet": "", "supplier_id_contanet": "",
           "intra_supplier_account": '',"intra_supplier_id_contanet": '',
           "intra_customer_account": '',"intra_customer_id_contanet": ''})
        }
        else{
          res.push(found_conf)
        }
      })
      conf.tipos_iva = res
      
    }
  return conf
}

const compare = (a,b)=>{
  if(a.tipo.includes('vat') && b.tipo.includes('igic'))
    return -1
  if(b.tipo.includes('vat') && a.tipo.includes('igic'))
    return 1

  return 0
}

class Connector {
  constructor({
    id,
    cif,
    name,
    tax_type,
    configuration,
    company,
    review,
    tolerancy,
    total_tolerancy,
    path_supplier_folder,
    path_customer_folder,
    iva_igic_no_deducible,
    comerciante_minorista,
    apply_415,
    payment_method_id_supplier,
    cartera_supplier,
    payment_method_id_customer,
    cartera_customer,
    cuenta_cartera_supplier,
    cuenta_cartera_customer,
    min_date,
    max_date,
    num_digits,
    links,
    type,
    type_name,
    companydb_type,
    projects,
    channels,
    activities,
    load_paths,
    accounts,
    automatic_payment_account,
    payment_account,
    automatic_charge_account,
    charge_account,
    to_upper,
    tagline_in_invoice,
    tagline_out_invoice,
    have_serie,
    series,
    cut_inv_num,
    num_chars_inv_num,
    chars_to_exclude,
    inv_num_boundary,
    exclude_inv_num_boundary,
    cut_cus_inv_num,
    num_chars_cus_inv_num,
    chars_to_exclude_cus,
    inv_num_boundary_cus,
    exclude_inv_num_boundary_cus,
    tagline_payment_move,
    tagline_charge_move,
    search_third_aprox,
    iva_agrario_pesca,
    iva_tabaco,
    force_exempt_supplier,
    force_exempt_customer,
    check_ret,
    auto_fill_due_date,
    prorate,
    invoice_description_order,
    oauth_session,
    oauth_session_state,
    decimal_separator,
    //third_selector_values,
    max_price,
    min_price,
    location_fk_id,
    location_file_fk_id,
    taxes,
    criterio_de_caja,
    available_features,
    abono_keywords,
    check_cif_in_docs,
    required_project,
    enable_fecha_sii,
    alfastar_serie_in,
    alfastar_serie_out,
    report_sii,
    hide_projects_master,
    hide_channels_master,
    hide_sections_master,
    hide_delegations_master,
    hide_departments_master,
    hide_activities_master,
    external_password,
    default_channel,
    link_filename_format,
    email_reclamacion_transacciones_bancarias,
    analytic_plans,
    is_archived,
    ...rest
  }) {
    this.id = id;
    this.cif = cif;
    this.name = name;
    this.tax_type = tax_type;
    this.configuration = add_tipos(JSON.parse(JSON.stringify(configuration)));
    if ('tipos_iva' in this.configuration) { 
      this.configuration['tipos_iva'].sort(compare)
    }
    this.company = company;
    this.review = review;
    this.tolerancy = tolerancy;
    this.total_tolerancy = total_tolerancy;
    this.path_supplier_folder = path_supplier_folder;
    this.path_customer_folder = path_customer_folder;
    this.iva_igic_no_deducible = iva_igic_no_deducible;
    this.comerciante_minorista = comerciante_minorista;
    this.apply_415 = apply_415;
    this.payment_method_id_supplier = payment_method_id_supplier;
    this.cartera_supplier = cartera_supplier;
    this.payment_method_id_customer = payment_method_id_customer;
    this.cartera_customer = cartera_customer;
    this.cuenta_cartera_supplier = cuenta_cartera_supplier;
    this.cuenta_cartera_customer = cuenta_cartera_customer;
    this.min_date = min_date;
    this.max_date = max_date;
    this.num_digits = num_digits;
    this.type = type;
    this.type_name = type_name;
    this.companydb_type = companydb_type;
    this.projects = projects;
    this.channels = channels;
    this.activities = activities;
    this.load_paths = load_paths;
    this.accounts = accounts;
    // this.links = [{
    //   link_path: "",
    //   min_date: moment('01/01','DD/MM').format('YYYY-MM-DD'),
    //   max_date: moment('31/12','DD/MM').format('YYYY-MM-DD'),
    //   start_ejercicio: moment('01/01','DD/MM').format('YYYY-MM-DD'),
    //   end_ejercicio: moment('31/12','DD/MM').format('YYYY-MM-DD'),
    //   year_ejercicio: moment('01/01','DD/MM').year(),
    //   deleted:false, active: true,
    // }]
    this.automatic_payment_account = automatic_payment_account
    this.payment_account = payment_account
    this.automatic_charge_account = automatic_charge_account
    this.charge_account = charge_account
    this.to_upper = to_upper
    this.tagline_in_invoice = tagline_in_invoice
    this.tagline_out_invoice = tagline_out_invoice
    this.have_serie = have_serie
    this.series = series
    this.cut_inv_num = cut_inv_num
    this.num_chars_inv_num = num_chars_inv_num
    this.chars_to_exclude = chars_to_exclude
    this.inv_num_boundary = inv_num_boundary
    this.exclude_inv_num_boundary = exclude_inv_num_boundary
    this.cut_cus_inv_num = cut_cus_inv_num
    this.num_chars_cus_inv_num = num_chars_cus_inv_num
    this.chars_to_exclude_cus = chars_to_exclude_cus
    this.inv_num_boundary_cus = inv_num_boundary_cus
    this.exclude_inv_num_boundary_cus = exclude_inv_num_boundary_cus
    this.tagline_payment_move = tagline_payment_move
    this.tagline_charge_move = tagline_charge_move
    this.search_third_aprox = search_third_aprox
    this.iva_agrario_pesca = iva_agrario_pesca
    this.iva_tabaco = iva_tabaco
    this.force_exempt_supplier = force_exempt_supplier
    this.force_exempt_customer = force_exempt_customer
    this.check_ret = check_ret
    this.auto_fill_due_date = auto_fill_due_date
    this.prorate = prorate
    this.invoice_description_order = invoice_description_order
    this.oauth_session = oauth_session
    this.oauth_session_state = oauth_session_state
    this.decimal_separator = decimal_separator
    this.max_price = max_price
    this.min_price = min_price
    //this.third_selector_values = third_selector_values? third_selector_values:[]
    this.location_fk_id = location_fk_id
    this.location_file_fk_id = location_file_fk_id
    this.taxes = taxes
    this.criterio_de_caja = criterio_de_caja;
    this.available_features = available_features
    this.abono_keywords = abono_keywords
    this.check_cif_in_docs = check_cif_in_docs
    this.required_project = required_project
    this.enable_fecha_sii = enable_fecha_sii
    this.alfastar_serie_in = alfastar_serie_in
    this.alfastar_serie_out = alfastar_serie_out
    this.report_sii = report_sii
    this.hide_projects_master = hide_projects_master
    this.hide_channels_master = hide_channels_master
    this.hide_sections_master = hide_sections_master
    this.hide_delegations_master = hide_delegations_master
    this.hide_departments_master = hide_departments_master
    this.hide_activities_master = hide_activities_master
    this.external_password = external_password
    this.default_channel = default_channel
    this.link_filename_format = link_filename_format
    this.email_reclamacion_transacciones_bancarias = email_reclamacion_transacciones_bancarias
    this.analytic_plans = analytic_plans
    this.is_archived = is_archived
    this.links = [{
      link_path: "",
      min_date: DateTime.fromFormat('01/01','dd/MM').toFormat('yyyy-MM-dd'),
      max_date: DateTime.fromFormat('31/12','dd/MM').toFormat('yyyy-MM-dd'),
      start_ejercicio: DateTime.fromFormat('01/01','dd/MM').toFormat('yyyy-MM-dd'),
      end_ejercicio: DateTime.fromFormat('31/12','dd/MM').toFormat('yyyy-MM-dd'),
      year_ejercicio: DateTime.fromFormat('01/01','dd/MM').year,
      prorate_percent: 'N/A',
      deleted:false, 
      active: true,
    }]
    if(links.length>0)
      this.links = links.map((x)=>Object.assign({deleted:false,link_path_aux:x.link_path},x))
  }
}

const models = {
  Connector
};

// initial state
const state = () => ({
  id: undefined,
  connector: undefined,
  connectorLoading: false,
  connectorError: false,
  connectorWriteLoading: false,
  connectorWriteError: false,
  rowsPerPage: 10,
  nstfilespaths: [],

  currentFilters: '',
  filtersData: {
    company__name__icontains: {
      'name': 'company__name__icontains', 
      'label': 'Nombre de empresa',
      'value': ''
    },
    company__nif__icontains: {
      'name': 'company__nif__icontains', 
      'label': 'CIF de empresa',
      'value': ''
    },
    name__icontains:{
      'name': 'name__icontains', 
      'label': 'Ruta',
      'value': ''
    },
  },
  show_message: false,
  type_choices: [],
  companydb_types: [],
  load_path_types: [],
  locations: [],

  jobState: 'done',
  asyncJobId: 0,
  importErrors: {},

  companyid_labels: {
    'contanet': 'Ruta al fichero .NST de Contanet',
    'aplifisa': 'Código de empresa de Aplifisa',
    'aplifisa_fiscal': 'Código de empresa Aplifisa Fiscal',
    'contasol': 'Código de empresa de Contasol (XXXYYYY)',
    'a3': 'Código de empresa de A3 (EXXXXX)',
    'monitor': 'Código de empresa de Monitor Informática',
    'sage': 'Código de empresa de SAGE',
    'sage_despachos': 'Código de empresa de SAGE Despachos',
    'csv_facturas': 'Código de empresa de CSV Facturas',
    'csv_asientos': 'Código de empresa de CSV Asientos',
    'api_facturas': 'Código de empresa de API Facturas',
    'api_asientos': 'Código de empresa de API Asientos',
  },

  actions: [
    { 'id': 'download_excel_companydbs', 'name': 'Exportar Empresas en Excel', 'group': 'action', 'excel': true },
    { 'id': 'delete', 'name': 'Borrar Empresas', 'group': 'action', 'excel': false },
    // { 'id': 'massive_change', 'name': 'Cambios Masivos', 'excel': false},
    { 'id': 'refresh_accounts', 'name': 'Actualizar Proveedores y Clientes masivamente', 'group': 'action', 'excel': false, 'feature': 'feature_massive_refresh_connector_accounts' },
    { 'id': 'massive_add_link', 'name': 'Crear ejercicio de forma masiva', 'group': 'action', 'excel': false, 'feature': 'feature_massive_companydb_link_creation' },
    { 'id': 'massive_deactivate_link', 'name': 'Desactivar ejercicio de forma masiva', 'group': 'action', 'excel': false, 'feature': 'feature_massive_companydb_link_creation' },
    { 'id': 'massive_change_link', 'name': 'Cambiar fecha límite de forma masiva', 'group': 'action', 'excel': false, 'feature': 'feature_massive_companydb_link_change_date' },
    { 'id': 'download_massive_csv', 'name': 'Descargar CSV', 'group': 'action', 'excel': false, 'feature': 'feature_csv_multiple_companies' },
    { 'id': 'account_massive_csv', 'name': 'Contabilizar las facturas del CSV', 'group': 'action', 'excel': false, 'feature': 'feature_csv_multiple_companies' },
    { 'id': 'massive_update_confirmation_mail', 'name': 'Cambiar confirmación de recepción de emails de puntos de carga', 'group': 'action', 'excel': false, 'feature': 'feature_massive_update_confirmation_email' },
    { 'id': 'massive_update_load_paths', 'name': 'Actualizar puntos de carga', 'group': 'action', 'excel': false, 'feature': 'feature_massive_update_load_paths' },
    { 'id': 'massive_update_is_archived', 'name': 'Archivar / Habilitar empresas', 'group': 'action', 'excel': false, 'admin_owner': true, 'feature': 'feature_archive_companies' },
  ],

  csv_one_line_headers: [],
  csv_one_line_hidden_headers: [],
  csv_multi_line_headers: [],
  csv_multi_line_hidden_headers: [],
  cdbs_with_settings: [],
  showMessages: {
    pending_training: {
      message: 'Para poder crear este connector, antes necesita hacer la formación. Nuestro equipo la está preparando. En breve, nos pondremos en contacto con usted.',
      show: false
    },
    init_instalation: {
      message: 'Para poder crear esta empresa, antes necesita instalar el conector de Inmatic en su servidor. ¿Desea empezar ahora su instalación?',
      show: false
    }
  },
  oauth_params: '',

  number_series_labels: {
    'number_serie_supplier': 'Factura proveedor',
    'number_serie_customer': 'Factura cliente'
  },

  taxes_labels: {
    's_iva_0': 'Venta - IVA 0 %',
    'p_iva_0': 'Gasto - IVA 0 %',
    'p_iva_d_21': 'Gasto - IVA 21 % (deducible)',
    'p_iva_nd_21': 'Gasto - IVA 21 % (no deducible)',
    'p_iva_75': 'Gasto - IVA 7.5 %',
    'p_iva_5': 'Gasto - IVA 5 %',
    'p_iva_2': 'Gasto - IVA 2 %',
    'p_igic_0': 'Gasto - IGIC 0 %',
    'p_igic_1': 'Gasto - IGIC 1 %',
    'p_igic_3': 'Gasto - IGIC 3 %',
    'p_igic_5': 'Gasto - IGIC 5 %',
    'p_igic_7': 'Gasto - IGIC 7 %',
    'p_igic_9': 'Gasto - IGIC 9,5 %',
    'p_igic_15': 'Gasto - IGIC 15 %',
    'p_igic_20': 'Gasto - IGIC 20 %',
    's_igic_0': 'Venta - IGIC 0 %',
    's_igic_1': 'Venta - IGIC 1 %',
    's_igic_3': 'Venta - IGIC 3 %',
    's_igic_5': 'Venta - IGIC 5 %',
    's_igic_7': 'Venta - IGIC 7 %',
    's_igic_9': 'Venta - IGIC 9,5 %',
    's_igic_15': 'Venta - IGIC 15 %',
    's_igic_20': 'Venta - IGIC 20 %',
    'p_iva_dp': 'Gasto - IVA Prorata (deducible)',
    'p_iva_ndp': 'Gasto - IVA Prorata (no deducible)',
    'p_iva_invsuj': 'Gasto - Inversión Sujeto Pasivo IVA',
    'p_igic_invsuj': 'Gasto - Inversión Sujeto Pasivo IGIC',
  }
})

const getters = {
  getField,
  connectorFetched: state => !!state.id && !state.connectorLoading && !state.connectorError && !!state.connector,
  currentConnector: state => state.connector,
  connectorWriting: state => state.connectorWriteLoading,
  rowsPerPage: state => state.rowsPerPage,
  get_nstpaths: state => state.nstfilespaths,
  showMessages: state => state.showMessages
}

// actions
const fetchConnector = async ({ commit }, { id }) => {
  commit(FETCH_CONNECTOR_BEGIN);
  
  try {
    const response = await api_connector.getConnector({ id })
    const { data } = response;
    if(data.min_date){
      let d_str_split = data.min_date.split('-')
      data.min_date = d_str_split[2]+'/'+d_str_split[1]+'/'+d_str_split[0]
    }
    if(data.max_date){
      let d_str_split_max = data.max_date.split('-')
      data.max_date = d_str_split_max[2]+'/'+d_str_split_max[1]+'/'+d_str_split_max[0]
    }
    const connector = new Connector(data);
    commit(FETCH_CONNECTOR_SUCCESS, { connector });
    return response;
  } catch (error) {
    console.log(error);
    commit(FETCH_CONNECTOR_ERROR);
    throw error;
  }
};

const resetConnector = function({ commit }){
  commit(RESET_CONNECTOR);
}

// const setRowsPerPage = function({commit}, rowsNumber) {
//   console.log('------------------------------------')
//   console.log(rowsNumber)

//   commit(SET_ROWS_PER_PAGE, rowsNumber);
// };

const exportConn = ({state}, { url, ids, send_filters, currentCompany }) => {
  return new Promise((resolve, reject)=> {
      let params = {};
      if (send_filters) {
          let filts = ''
          for (let filter in state.filtersData) {
              if (state.filtersData[filter].value) {
                  filts += "&" + filter + "=" + state.filtersData[filter].value;
              }        
          }
          params['filters'] = filts;
          params['cdb'] = currentCompany.id;
      } else {
          params['ids'] = ids;
      }
      
      client.post(url, params).then(resp => {
          resolve(resp);
      }).catch(err => {
          reject(err);
      });
  });
}

const addRefreshAccountsAction = ({ commit, rootGetters }) => {
  if (rootGetters['me/userData']['available_features']['feature_massive_refresh_connector_accounts']) {
    commit(ADD_REFRESH_ACCOUNTS_ACTION);
  }
}

const addMassiveCompanyDBLinkAction = ({ commit, rootGetters }) => {
  if (rootGetters['me/userData']['available_features']['feature_massive_companydb_link_creation']) {
    commit(ADD_MASSIVE_COMPANYDB_LINK_ACTION);
    commit(ADD_MASSIVE_DEACTIVATE_COMPANYDB_LINK_ACTION);
  }
}

const changeMassiveCompanyDBLinkAction = ({ commit, rootGetters }) => {
  if (rootGetters['me/userData']['available_features']['feature_massive_companydb_link_change_date']) {
    commit(CHANGE_MASSIVE_COMPANYDB_LINK_ACTION);
  }
}

const massiveUpdate = ({}, { ids, params }) => {
  return new Promise((resolve, reject)=> {
    client.patch('massive_update_companydb/', { 'ids': ids, 'params': params }).then(response => {
      resolve(response);
    }).catch(err=>{
      var response = JSON.parse(err.request.response);
      console.error(response)
      reject();
    });
  });
}

const massiveAddCompanyDBLink = ({}, { ids, min_date, max_date, start_ejercicio, end_ejercicio, year_ejercicio }) => {
  const params = { 
    'ids': ids, 
    'min_date': min_date, 
    'max_date': max_date,
    'start_ejercicio': start_ejercicio,
    'end_ejercicio': end_ejercicio,
    'year_ejercicio': year_ejercicio,
  }
  return new Promise((resolve, reject)=> {
    client.patch('massive_companydb_link_creation/', params).then(response => {
      resolve(response);
    }).catch(err=>{
      try {
        var response = JSON.parse(err.request.response);
        console.error(response);
      } catch {
        console.error(err)
      }
      reject();
    });
  });
}
const massiveChangeCompanyDBLink = ({}, { ids, type, year,date }) => {
  return new Promise((resolve, reject)=> {
    client.patch('massive_change_companydb_link/', { 'ids': ids, 'type': type, 'year': year,'date':date }).then(response => {
      resolve(response);
    }).catch(err=>{
      try {
        var response = JSON.parse(err.request.response);
        console.error(response);
      } catch {
        console.error(err)
      }
      reject();
    });
  });
}

const massiveDeactivateCompanyDBLink = ({}, { ids, year }) => {
  return new Promise((resolve, reject) => {
    client.patch('massive_unactivate_companydb_link/', { 'ids': ids, 'year': year }).then(response => {
      resolve(response);
    }).catch(err=>{
      try {
        var response = JSON.parse(err.request.response);
        console.error(response);
      } catch {
        console.error(err)
      }
      reject();
    });
  });
}

const massiveCreateConnectors = ({}, { file }) => {
  return new Promise((resolve, reject) => {
    let formData = new FormData();
    formData.append('file', file);
    client.post('massive_create_connectors/', formData).then(response => {
      resolve(response);
    }).catch(err=>{
      try {
        var response = JSON.parse(err.request.response);
        console.error(response);
      } catch {
        console.error(err)
      }
      reject();
    });
  });
}

const setColumnDataIfParams = ({ commit },data) => {
  if(data['params']){
    if(data['params']['show']){
      commit(SET_CSV_ONE_LINE_HEADERS, data['params']['show']);
    }
    if(data['params']['hide']){
      commit(SET_CSV_ONE_LINE_HIDDEN_HEADERS, data['params']['hide']);
    }  
  }
}
const getColumnsCsvOneLine = ({ commit, rootGetters }, cdb_id) => {
  return new Promise((resolve, reject) => {
    if (cdb_id) {
      let url = 'settings/get_setting_csv/csv_facturas_one_line_headers/' + rootGetters["me/userData"]['user'] + '/' + cdb_id + '/';
      client.get(url).then(resp => {
        setColumnDataIfParams({ commit },resp.data);
        resolve();
      }).catch(err => {
        console.debug(err);
        reject(err);
      });
    } else {
      commit(SET_CSV_ONE_LINE_HEADERS, []);
      commit(SET_CSV_ONE_LINE_HIDDEN_HEADERS, []);
      resolve();
    }
  });
}

const setColumnsCsvOneLine = ({ state, rootGetters }, cdb_id) => {
  return new Promise((resolve, reject) => {
    if (cdb_id) {
      let url = 'settings/set_setting/csv_facturas_one_line_headers/' + rootGetters["me/userData"]['user'] + '/' + cdb_id + '/';
      let params = { 'payload': { 'show': state.csv_one_line_headers, 'hide': state.csv_one_line_hidden_headers }};
      client.patch(url, params).then(() => {
        resolve();
      }).catch(err => {
        console.debug(err);
        reject(err);
      });
    } else {
      reject();
    }
  });
}
const getCdbWithSettings = ({ commit },{settings_code, cdb_id,}) => {
  return new Promise((resolve, reject) => {
      let url = 'settings/get_cdbs_with_settings/'+ settings_code + '/' + cdb_id + '/';
      client.get(url).then(resp => {
        commit(SET_USERS_CDB_WITH_SETTINGS, resp.data);
        resolve();
      }).catch(err => {
        console.debug(err);
        reject(err);
      });
  });
}

const checkCompanyApi = async ({ }, { company_id, route}) => {
  return api_connector.checkCompany({ company_id, route});
};

const getOpenIdUserSessions = async ({ },data) => {
  return new Promise((resolve, reject) => {
    let url = 'oauth2/get_user_sessions/';
    let params = {params:{...data}}
    client.get(url,params).then(resp => {
      resolve(resp.data);
    }).catch(err => {
      console.debug(err);
      reject(err);
    });
  });
};
const validateUser = async ({ } ,{oauth_params, data={}}) => {
  return new Promise((resolve, reject) => {
    let url = 'oauth2/authorize/';
    let endpoint_data={ oauth_params , ...data };
    client.post(url, endpoint_data).then(resp => {
      resolve(resp.data);
    }).catch(err => {
      console.debug(err);
      reject(err);
    });
  });
};

const connectOuth2User = async ({ }, data) => {
  return new Promise((resolve, reject) => { 
    const url = 'oauth2/connect/';
    client.post(url,{...data}).then(resp => {
      if (resp.data){
        window.location.href = resp.data;  
      }
      resolve();
    }).catch(err => {
      console.debug(err);
      reject(err);
    });
  }) 
};

const setOauthData = async ({ commit ,dispatch}, oauth_params) => {

  return new Promise((resolve, reject) => {
    commit(SET_OAUTH_PARAMS, oauth_params.params);

    const urlParams = new URLSearchParams(oauth_params.params);
    let url_state = urlParams.get('state');
    if (url_state.match('^\\/\\d+\\/[\\w-]+$')) {
      let companydb = parseInt(url_state.toString().split('/').at(1));
      let data = {value: 'innuva'};
      dispatch("validateUser",{ oauth_params:oauth_params.params, data });
    }
    resolve(url_state);
  });
}

const getUserCompanies = async ({}, id) => {
  return new Promise((resolve, reject) => {
    let url = 'oauth2/get_companies/' + id + '/';
    client.get(url).then(resp => {
      resolve(resp.data);
    }).catch(err => {
      console.debug(err);
      reject(err);
    });
  });
}
const createConnProject = ({state,dispatch},{name, external_id, companydb, references} ) => {
  return new Promise(
    (resolve,reject) => {
      client.post("/create_companydb_project/", {
        "name" : name,
        "external_id" : external_id,
        "companydb" : companydb,
        "references": references,
      }).then((response) => {
        resolve(response.data);
      }).catch(err => {
        reject(err);
      });
    }
  )
}
const updateConnProject = ({dispatch},{name, external_id, project, references} ) => {
  return new Promise(
    (resolve,reject) => {
      client.patch("/update_companydb_project/", {
        "name" : name,
        "external_id" : external_id,
        "project" : project,
        "references": references,
      }).then((response) => {
        dispatch('saveActivities', { activities : response.data.results }, {root:true})
        resolve(response.data);
      }).catch(err => {
        reject(err);
      });
    }
  )
}
const deleteConnProject = ({state},{project_ids, search_filters, companydb_id}) => {
  return new Promise((resolve,reject) => {
      let params = {
        "project_ids": project_ids,
        "search_filters": search_filters,
        "companydb_id": companydb_id,
      };
      client.post('delete_companydb_project/', params).then(resp => {
        resolve(resp.data);
      }).catch(err => {
        reject(err);
      });
    }
  )
}


const createConnChannel = ({state,dispatch},{name, external_id, companydb, references} ) => {
  return new Promise(
    (resolve,reject) => {
      client.post("/create_companydb_channel/", {
        "name" : name,
        "external_id" : external_id,
        "companydb" : companydb,
        "references": references,
      }).then((response) => {
        resolve(response.data);
      }).catch(err => {
        reject(err);
      });
    }
  )
}
const updateConnChannel = ({dispatch},{name, external_id, channel, references} ) => {
  return new Promise(
    (resolve,reject) => {
      console.log(name, external_id, channel, references)
      client.patch("/update_companydb_channel/", {
        "name" : name,
        "external_id" : external_id,
        "channel" : channel,
        "references": references,
      }).then((response) => {
        dispatch('saveActivities', { activities : response.data.results }, {root:true})
        resolve(response.data);
      }).catch(err => {
        reject(err);
      });
    }
  )
}
const deleteConnChannel = ({state}, {channel_ids, search_filters, companydb_id}) => {
  return new Promise((resolve,reject) => {
      let params = {
        "channel_ids": channel_ids,
        "search_filters": search_filters,
        "companydb_id": companydb_id,
      };
      client.post('delete_companydb_channel/', params).then(resp => {
        resolve(resp.data);
      }).catch(err => {
        reject(err);
      });
    }
  )
}

const createConnSection = ({state,dispatch},{name, external_id, companydb, references} ) => {
  return new Promise(
    (resolve,reject) => {
      client.post("/create_companydb_section/", {
        "name" : name,
        "external_id" : external_id,
        "companydb" : companydb,
        "references": references,
      }).then((response) => {
        resolve(response.data);
      }).catch(err => {
        reject(err);
      });
    }
  )
}
const updateConnSection = ({dispatch},{name, external_id, section, references} ) => {
  return new Promise(
    (resolve,reject) => {
      console.log(name, external_id, section, references)
      client.patch("/update_companydb_section/", {
        "name" : name,
        "external_id" : external_id,
        "section" : section,
        "references": references,
      }).then((response) => {
        dispatch('saveActivities', { activities : response.data.results }, {root:true})
        resolve(response.data);
      }).catch(err => {
        reject(err);
      });
    }
  )
}
const deleteConnSection = ({state}, {section_ids, search_filters, companydb_id}) => {
  return new Promise((resolve,reject) => {
      let params = {
        "section_ids": section_ids,
        "search_filters": search_filters,
        "companydb_id": companydb_id,
      };
      client.post('delete_companydb_section/', params).then(resp => {
        resolve(resp.data);
      }).catch(err => {
        reject(err);
      });
    }
  )
}


const createConnDelegation = ({state,dispatch},{name, external_id, companydb, references} ) => {
  return new Promise(
    (resolve,reject) => {
      client.post("/create_companydb_delegation/", {
        "name" : name,
        "external_id" : external_id,
        "companydb" : companydb,
        "references": references,
      }).then((response) => {
        resolve(response.data);
      }).catch(err => {
        reject(err);
      });
    }
  )
}
const updateConnDelegation = ({dispatch},{name, external_id, delegation, references} ) => {
  return new Promise(
    (resolve,reject) => {
      console.log(name, external_id, delegation, references)
      client.patch("/update_companydb_delegation/", {
        "name" : name,
        "external_id" : external_id,
        "delegation" : delegation,
        "references": references,
      }).then((response) => {
        dispatch('saveActivities', { activities : response.data.results }, {root:true})
        resolve(response.data);
      }).catch(err => {
        reject(err);
      });
    }
  )
}
const deleteConnDelegation = ({state}, {delegation_ids, search_filters, companydb_id}) => {
  return new Promise((resolve,reject) => {
      let params = {
        "delegation_ids": delegation_ids,
        "search_filters": search_filters,
        "companydb_id": companydb_id,
      };
      client.post('delete_companydb_delegation/', params).then(resp => {
        resolve(resp.data);
      }).catch(err => {
        reject(err);
      });
    }
  )
}


const createConnDepartment = ({state,dispatch},{name, external_id, companydb, references} ) => {
  return new Promise(
    (resolve,reject) => {
      client.post("/create_companydb_department/", {
        "name" : name,
        "external_id" : external_id,
        "companydb" : companydb,
        "references": references,
      }).then((response) => {
        resolve(response.data);
      }).catch(err => {
        reject(err);
      });
    }
  )
}
const updateConnDepartment = ({dispatch},{name, external_id, department, references} ) => {
  return new Promise(
    (resolve,reject) => {
      console.log(name, external_id, department, references)
      client.patch("/update_companydb_department/", {
        "name" : name,
        "external_id" : external_id,
        "department" : department,
        "references": references,
      }).then((response) => {
        dispatch('saveActivities', { activities : response.data.results }, {root:true})
        resolve(response.data);
      }).catch(err => {
        reject(err);
      });
    }
  )
}
const deleteConnDepartment = ({state}, {department_ids, search_filters, companydb_id}) => {
  return new Promise((resolve,reject) => {
      let params = {
        "department_ids": department_ids,
        "search_filters": search_filters,
        "companydb_id": companydb_id,
      };
      client.post('delete_companydb_department/', params).then(resp => {
        resolve(resp.data);
      }).catch(err => {
        reject(err);
      });
    }
  )
}

const deleteConnExpensIncomeType = ({state}, {eit_ids, search_filters, companydb_id}) => {
  return new Promise((resolve,reject) => {
        let params = {
          "eit_ids": eit_ids,
          "search_filters": search_filters,
          "companydb_id": companydb_id,
        };
        client.post('delete_expens_income_type/', params).then(resp => {
          resolve(resp.data);
        }).catch(err => {
          reject(err);
        });
      }
  )
}

const createConnActivity = ({state,dispatch},{name,code} ) => {
  return new Promise(
    (resolve,reject) => {
      client.post("/create_companydb_activity/", {
        "name" : name,
        "code" : code,
        "companydb" : state.connector.id
      }).then((response) => {
        dispatch('saveActivities', { activities : response.data.results }, {root:true})
        resolve(response.data);
      }).catch(err => {
        reject(err);
      });
    }
  )
}
const deleteConnActivity = ({state},{act_ids, search_filters, companydb_id} ) => {
  return new Promise((resolve,reject) => {
      let params = {
        "act_ids": act_ids,
        "search_filters": search_filters,
        "companydb_id": companydb_id,
      };
      client.post('delete_companydb_activity/', params).then(resp => {
        resolve(resp.data);
      }).catch(err => {
        reject(err);
      });
    }
  )
}
const updateConnActivity = ({dispatch},{name, code, activity} ) => {
  return new Promise(
    (resolve,reject) => {
      client.patch("/update_companydb_activity/", {
        "name" : name,
        "code" : code,
        "activity" : activity
      }).then((response) => {
        dispatch('saveActivities', { activities : response.data.results }, {root:true})
        resolve(response.data);
      }).catch(err => {
        reject(err);
      });
    }
  )
}

const createConnLoadPath = ({ state }, { load_path_data }) => {
  return new Promise((resolve, reject) => {
    load_path_data['companydb'] = state.connector.id;
    client.post('create_load_path/', load_path_data).then(resp => {
      resolve(resp.data);
    }).catch(err => {
      console.error(err)
      reject(err);
    });
  });
}

const deleteConnLoadPath = ({ state }, { loadpath_ids, search_filters, companydb_id }) => {
  return new Promise((resolve, reject) => {
    let params = {
      "loadpath_ids": loadpath_ids,
      "search_filters": search_filters,
      "companydb_id": companydb_id,
    };
    client.post('delete_load_path/', params).then(resp => {
      
      resolve(resp.data);
    }).catch(err => {
      reject(err);
    });
  });
}

const updateConnLoadPath = ({ state }, { load_path, load_path_data }) => {
  return new Promise((resolve, reject) => {
    load_path_data['cdb'] = state.connector.id;
    load_path_data['load_path'] = load_path;
    client.patch('update_load_path/', load_path_data).then(resp => {
      resolve(resp.data);
    }).catch(err => {
      reject(err);
    });
  });
}


const createConnAccount = ({state, dispatch},{account, description} ) => {
  return new Promise(
    (resolve,reject) => {
      client.post("/create_account_app/", {
        "account" : account,
        "description" : description,
        "companydb" : state.connector.id
      }).then((response) => {
        resolve(response.data);
      }).catch(err => {
        reject(err);
      });
    }
  )
}

const updateConnAccount = ({state, dispatch},{account, description, account_id} ) => {
  return new Promise(
    (resolve,reject) => {
      client.patch("/update_account_app/", {
        "account" : account,
        "description" : description,
        "account_id" : account_id,
        "companydb" : state.connector.id
      }).then((response) => {
        resolve(response.data);
      }).catch(err => {
        reject(err);
      });
    }
  )
}

const deleteConnAccounts = ({ state }, { acc_ids, search_filters, companydb_id }) => {
  return new Promise((resolve, reject) => {
    let params = {
      "acc_ids": acc_ids,
      "search_filters": search_filters,
      "companydb_id": companydb_id,
    };
    client.post('delete_accounts/', params).then(resp => {
      resolve(resp.data);
    }).catch(err => {
      reject(err);
    });
  });
}

const setLoadPathTypes = ({ commit }) => {
  return new Promise((resolve, reject)=> {
    client.get('load_path_types/?limit=1000').then(resp => {
      // Los nombres de las apps de Google Drive los decide el backend (cada usuario ve las
      // suyas renombradas por posicion), asi que aqui ya llegan listos para mostrar.
      commit(SET_LOAD_PATH_TYPES, resp.data.results);
      resolve();
    }).catch(err => {
      reject(err);
    }); 
  });
}

const getLocations = ({ commit }, cdb_type_value) => {
  return new Promise((resolve, reject) => {
    client.get('get_companydb_type_locations/?cdb_type_value=' + cdb_type_value).then(resp => {
      commit(SET_LOCATIONS, resp.data.results);
      resolve();
    }).catch(err => {
      reject(err);
    });
  });
}

const actions = {
  fetchConnector,
  resetConnector,
  createCompanyDBUser(context, userData) {
    return new Promise((resolve, reject) => {
      client.post('create_companydb_user/', userData).then(resp => {
        resolve(resp);
      }).catch(err => {
        reject(err);
      })
    })
  },
  addCompanyDBUser(context, {userId, companyDBId, role_kind}) {
    return new Promise((resolve, reject) => {
      client.post('add_companydb_user/', {'user': userId, 'companyDB': companyDBId, 'role_kind': role_kind}).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      })
    })
  },
  updateCompanyDBUser(context, {user_id, email, kind, view_all_companies, default_role_kind, view_invoices, view_banks, view_e_invoice, view_gestor, view_working_hours, companydb_id}) {
    return new Promise((resolve, reject) => {
      let params = {
        'user_id': user_id,
        'email': email,
        'kind': kind,
        'view_all_companies': view_all_companies,
        'default_role_kind': default_role_kind,
        'view_invoices': view_invoices,
        'view_banks': view_banks,
        'view_e_invoice': view_e_invoice,
        'view_gestor': view_gestor,
        'view_working_hours': view_working_hours,
        'companydb_id': companydb_id
      };
      client.put('update_companydb_user/', params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      })
    })
  },
  deleteCompanyDBUser(context, {ucdbr_ids, companydb_id, search_filters}) {
    return new Promise((resolve, reject) => {
      let params = {
        'ucdbr_ids': ucdbr_ids,
        'companydb_id': companydb_id,
        'search_filters': search_filters,
      };
      client.post('delete_companydb_user/', params).then(resp => {
        resolve(resp);
      }).catch(err => {
        reject(err);
      })
    })
  },
  getFreeInvitedUsers(context, companyDBId) {
    return new Promise((resolve, reject) => {
      let params = {
        params: {
          companydb: companyDBId
        }
      };
      client.get('get_free_invited_users/', params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      })
    });
  },
  changePassCDBUser({}, {user_id, pass}) {
    return new Promise((resolve, reject) => {
      client.post('change_pass_cdb_user/', {'user_id': user_id, 'pass': pass}).then(resp => {
        resolve(resp);
      }).catch(err => {
        reject(err);
      })
    })
  },
  setRowsPerPage(context, rowsNumber) {  
    context.commit(SET_ROWS_PER_PAGE, rowsNumber);
  },
  refreshContanetPaths(context) {
    return new Promise((resolve, reject) => {
      client.patch('refresh_contanet_db_list/').then(resp => {
        resolve(resp);
      }).catch(err => {
        reject(err);
      });
    });
  },
  getLastGetContanetDBListOp({}) {
    return new Promise((resolve, reject) => {
      client.get('get_last_get_contanet_db_list_op/').then(resp => {
        resolve(resp.data);
      }).catch(err => {
        reject(err);
      });
    });
  },
  refreshAccounts({state}, ids) {
    return new Promise((resolve, reject) => {
      client.post('refresh_connector_accounts/', { 'ids': ids }).then(resp => {
        resolve(resp);
      }).catch(err => {
        reject(err);
      });
    });
  },
  getLastGetAccountsContanetOp({}, id) {
    return new Promise((resolve, reject) => {
      client.get('get_last_get_accounts_contanet_op/' + id + '/').then(resp => {
        resolve(resp.data);
      }).catch(err => {
        reject(err);
      });
    });
  },
  fetchRefreshProgressState(context, id) {
    return new Promise((resolve, reject) => {
      client.get('operations_progress/' + id + '/').then(resp => {
        resolve(resp);
      }).catch(err => {
        reject(err);
      });
    });
  },
  setNstpaths(context) {
    return new Promise((resolve, reject) => {
      client.get('nstfilespaths/?limit=100000').then(response => {
        context.commit('SET_NSTFILESPATHS', response.data.results)

        resolve();
      }).catch(error => { reject(error) });
    })
  },

  getFilters({ commit, state, dispatch }, filts) {
    commit(SET_CURRENT_FILTERS, filts);
    return true;

  },
  generateFilters({ state, dispatch }) {
    let filts = "";
    for (let filter in state.filtersData) {
      if (state.filtersData[filter].value) {
        filts += "&" + filter + "=" + state.filtersData[filter].value;
      }        
    }
    return dispatch("getFilters", filts)
  },
  cleanFilters({ commit, dispatch }) {
    commit(CLEAN_FILTERS);
    return dispatch("getFilters", "");
  },
  
  importFile(context, file) {
    return new Promise((resolve, reject) => {
      let formData = new FormData();
      formData.append('cdb', context.state.connector.id);
      formData.append('file', file);
      client.post('import_customers_suppliers/', formData).then(response => {
        context.commit(SET_ASYNC_JOB_ID, response.data['AsyncJob']);
        context.commit(SET_ASYNC_JOB_STATE, 'running');
        resolve(response);
      }).catch(error => { 
        reject(error) ;
      });
    });
  },

  setCompanyDBTypes({ commit }) {
    return new Promise((resolve, reject) => {
      client.get('get_user_companydb_types/').then(resp => {
        commit(SET_COMPANYDB_TYPES, resp.data['companydb_types']);
        // commit(SET_TYPE_CHOICES, resp.data['companydb_types']);
        resolve();
      }).catch(err => {
        reject(err);
      }); 
    });
  },
  getFolders({},{session, path, showReadOnly}) {
    return new Promise((resolve, reject) => {
      let url = "get_cloud_directory/";
      let params = {params:{path,showReadOnly}}
      client.get(url+session,params).then((response) => {
        resolve(response);
      }).catch(err => {
        if (err.response.status === 401) {
          resolve(err.response);
        } else{
          reject(err);
        }
      }); 
    });
  },
  updateAbonoKeywords({ commit }, val){
    commit('updateAbonoKeywords', val)
  },
  exportConn,
  addRefreshAccountsAction,
  addMassiveCompanyDBLinkAction,
  changeMassiveCompanyDBLinkAction,
  massiveUpdate,
  massiveAddCompanyDBLink,
  massiveChangeCompanyDBLink,
  activeInstalationMessage: ({commit, state, dispatch}) => {
    commit(ACTIVE_INSTALATION_MESSAGE);
  },
  inactiveInstalationMessage: ({commit, state, dispatch}) => {
    commit(INACTIVE_INSTALATION_MESSAGE);
  },
  activeTrainingMessage: ({commit, state, dispatch}) => {
    commit(ACTIVE_TRAINING_MESSAGE);
  },
  inactiveTrainingMessage: ({commit, state, dispatch}) => {
    commit(INACTIVE_TRAINING_MESSAGE);
  },
  massiveDeactivateCompanyDBLink,
  getColumnsCsvOneLine,
  setColumnsCsvOneLine,
  checkCompanyApi,
  getCdbWithSettings,
  setColumnDataIfParams,
  getOpenIdUserSessions,
  connectOuth2User,
  setOauthData,
  validateUser,
  getUserCompanies,
  createConnProject,
  updateConnProject,
  deleteConnProject,
  createConnChannel,
  updateConnChannel,
  deleteConnChannel,
  createConnActivity,
  deleteConnActivity,
  updateConnActivity,
  createConnLoadPath,
  deleteConnLoadPath,
  updateConnLoadPath,
  createConnAccount,
  deleteConnAccounts,
  updateConnAccount,
  setLoadPathTypes,
  getLocations,
  deleteConnExpensIncomeType,
  createConnSection,
  updateConnSection,
  deleteConnSection,
  createConnDelegation,
  updateConnDelegation,
  deleteConnDelegation,
  createConnDepartment,
  updateConnDepartment,
  deleteConnDepartment,
  massiveCreateConnectors
}

// mutations
const mutations = {
  updateField,
  [FETCH_CONNECTOR_SUCCESS](state, { connector }) {
    state.connectorLoading = false;
    state.connectorError = false;
    state.connector = { ...connector };
  },
  [FETCH_CONNECTOR_BEGIN](state) {
    state.connectorLoading = true;
    state.docError = false;
  },
  [FETCH_CONNECTOR_ERROR](state) {
    state.connectorLoading = false;
    state.connectorError = true;
  },
  [WRITE_CONNECTOR_SUCCESS](state, { connector }) {
    state.connectorWriteLoading = false;
    state.connectorWriteError = false;
    state.connector = { ...connector };
  },
  [WRITE_CONNECTOR_BEGIN](state) {
    state.connectorWriteLoading = true;
    state.connectorWriteError = false;
  },
  [WRITE_CONNECTOR_ERROR](state) {
    state.connectorWriteLoading = false;
    state.connectorWriteError = true;
  },
  [RESET_CONNECTOR](state) {
    state.connector = {
      name:'',configuration:
      {"tipos_iva": []
      },
      links: [],
      review: true,
    }
  },
  [SET_ROWS_PER_PAGE](state, rowsPerPage) {
    state.rowsPerPage = rowsPerPage;
  },
  [SET_NSTFILESPATHS](state, value) {
    state.nstfilespaths = value
  },

  [SET_CURRENT_FILTERS](state, filts) {
    state.currentFilters = filts;
  },
  [CLEAN_FILTERS](state) {
    for (let i in state.filtersData) {
      state.filtersData[i].value = '';
    }
  },
  [SET_TYPE_CHOICES](state, type_choices) {
    state.type_choices = type_choices;
  },
  [SET_COMPANYDB_TYPES](state, companydb_types) {
    state.companydb_types = companydb_types;
  },
  [SET_LOAD_PATH_TYPES](state, load_path_types) {
    state.load_path_types = load_path_types;
  },
  [SET_LOCATIONS](state, locations) {
    state.locations = locations;
  },
  [SET_ASYNC_JOB_ID](state, jobId) {
    state.asyncJobId = jobId;
  },
  [SET_ASYNC_JOB_STATE](state, jobState) {
    state.jobState = jobState;
  },
  [ADD_REFRESH_ACCOUNTS_ACTION](state) {
    const found = state.actions.some(el => el.id === 'refresh_accounts');
    if(!found){
      // state.actions.push();
    }
  },
  [ADD_MASSIVE_COMPANYDB_LINK_ACTION](state) {
    const found = state.actions.some(el => el.id === 'massive_add_link');
    if(!found){
      // state.actions.push({ 'id': 'massive_add_link', 'name': 'Crear ejercicio de forma masiva', 'group': 'action', 'excel': false, 'feature': 'feature_massive_companydb_link_creation' });
    }
  },
  [CHANGE_MASSIVE_COMPANYDB_LINK_ACTION](state) {
    const found = state.actions.some(el => el.id === 'massive_change_link');
    if(!found){
      // state.actions.push({ 'id': 'massive_change_link', 'name': 'Cambiar fecha límite ejercicio de forma masiva', 'excel': false });
    }
  },
  [ACTIVE_TRAINING_MESSAGE](state) {
    state.showMessages.pending_training.show = true;
  },
  [INACTIVE_TRAINING_MESSAGE](state) {
    state.showMessages.pending_training.show = false;
  },
  [ACTIVE_INSTALATION_MESSAGE](state) {
    state.showMessages.init_instalation.show = true;
  },
  [INACTIVE_INSTALATION_MESSAGE](state) {
    state.showMessages.init_instalation.show = false;
  },
  [ADD_MASSIVE_DEACTIVATE_COMPANYDB_LINK_ACTION](state) {
    const found = state.actions.some(el => el.id === 'massive_deactivate_link');
    if(!found){
      // state.actions.push();
    }
  },
  [SET_CSV_ONE_LINE_HEADERS](state, headers) {
    state.csv_one_line_headers = headers;
  },
  [SET_CSV_ONE_LINE_HIDDEN_HEADERS](state, headers) {
    state.csv_one_line_hidden_headers = headers;
  },
  [SET_CSV_MULTI_LINE_HEADERS](state, headers) {
    state.csv_multi_line_headers = headers;
  },
  [SET_CSV_MULTI_LINE_HIDDEN_HEADERS](state, headers) {
    state.csv_multi_line_hidden_headers = headers;
  },
  [SET_USERS_CDB_WITH_SETTINGS](state, cdb_list) {
    state.cdbs_with_settings = cdb_list;
  },
  [SET_OAUTH_PARAMS](state, params) {
    state.oauth_params = params;
  },
  [SET_OAUTH_APP](state, data) {
    state.oauth_app = data;
  },
  updateAbonoKeywords(state, val) {
    state.connector.abono_keywords = [];
    for(let i in val){
      state.connector.abono_keywords.push(val[i]);
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  models,
}
